module.exports = __webpack_public_path__ + "static/confetti-left-83a8e2f145c2daeaff440b2ee98a22bf.png";